import Paragraph from 'antd/lib/typography/Paragraph';

import {Text} from '../../../../../component/text/text';
import {VideoDurationTag} from '../../../../../component/video-duration-tag/video-duration-tag';
import {classNames} from '../../../../../util/css';
import {KnowledgeHelpVideoType} from '../knowledge-help-videos-type';

import * as styles from './knowledge-video-item.scss';

type PropsType = {
    item: KnowledgeHelpVideoType;
    onClick: () => void | null;
    selected: boolean;
};

export function KnowledgeVideoItem(props: PropsType): JSX.Element {
    const {item, onClick, selected} = props;

    return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events
        <div
            className={classNames(styles.KnowledgeVideoItem, {
                [styles.KnowledgeVideoItem__selected]: selected,
            })}
            onClick={() => onClick?.()}
            role="button"
            tabIndex={0}
        >
            <div className={styles.KnowledgeVideoItem_thumbWrapper}>
                <img alt={item.config.title} className={styles.KnowledgeVideoItem_thumb} src={item.config.previewUrl} />

                <VideoDurationTag durationMillis={item.config.durationSec * 1000} />
            </div>

            <div className={styles.KnowledgeVideoItem_content}>
                <Paragraph color="inherit" ellipsis={{rows: 2}}>
                    <Text bolder large>
                        {item.config.title}
                    </Text>
                </Paragraph>

                <Text block secondary>
                    <Paragraph color="inherit" ellipsis={{rows: 2}}>
                        <Text secondary>{item.config.description}</Text>
                    </Paragraph>
                </Text>
            </div>
        </div>
    );
}
